// extracted by mini-css-extract-plugin
export default {"contactContainer":"Contact_contactContainer__tJ5sm","contactBox":"Contact_contactBox__-ZKtm","contactIconBox":"Contact_contactIconBox__G5eCD"};